import { lazy } from 'react'

export const ReasonToGiveUp = lazy(() => import('./ReasonToGiveUp'))
